import React, { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';

import { evSponsoredProductClick, evSponsoredProductView } from 'events/search';

import { toUSD } from 'helpers/NumberFormats';
import { trackEvent } from 'helpers/analytics';
import { track } from 'apis/amethyst';
import MelodyCardProduct from 'components/common/melodyCard/MelodyCardProduct';
import Tooltip from 'components/common/Tooltip';
import { MoreInfo } from 'components/icons';
import styles from 'styles/components/search/sponsoredProducts.scss';

const SponsoredProducts = ({ onHeartClick, showHearting, hearts, msaImageParams, showRatingStars, heartsList, heartsData, sponsoredProducts, searchTerm }, { testId, marketplace: { shortName } }) => {
  const additionalMelodyCardProductClasses = { container: styles.product };

  const handleSponsoredProductClick = useCallback(({ index, styleId }) => {
    track(evSponsoredProductClick, { productIndex: index, styleId });
    trackEvent('TE_SPONSORED_PRODUCT_CLICK', `styleId:${styleId}productIndex:${index}:searchTerm:${searchTerm}`);
  }, [searchTerm]);

  useEffect(() => {
    const styleIds = sponsoredProducts.styles.map(style => style.styleId);
    trackEvent('TE_SPONSORED_PRODUCTS_VIEW', `styles:${styleIds}:searchTerm:${searchTerm}`);
    track(evSponsoredProductView, { sponsoredProducts });
  }, [searchTerm, sponsoredProducts]);

  return (
    <aside className={styles.searchSponsoredProductsContainer}>
      <h2 className={styles.title}>Sponsored Products</h2>
      <Tooltip
        content={`These are ads for products you'll find on ${shortName}.com. Clicking an ad will take you to the product's page.`}
        wrapperClassName={styles.tooltipWrapper}
        tooltipClassName={styles.tooltip}
        direction="down"
        sponsored={true}
        tooltipId="sponsoredProducts"
      >
        <MoreInfo />
      </Tooltip>
      <div className={styles.products}>
        {sponsoredProducts.styles.map((product, index) => {
          // Massage data for price formatting
          const cardData = {
            ...product,
            price: toUSD(product.price),
            originalPrice: toUSD(product.originalPrice),
            isSponsored: true
          };
          return (
            <MelodyCardProduct
              key={`${product.styleId}`}
              onComponentClick={() => handleSponsoredProductClick({ index, styleId: product.styleId })}
              componentStyle="searchProductInlineRecos"
              heartsData={heartsData}
              showFavoriteHeart={showHearting}
              onHeartClick={onHeartClick}
              hearts={hearts}
              additionalClasses={additionalMelodyCardProductClasses}
              cardData={cardData}
              msaImageParams={msaImageParams}
              melodyCardTestId={testId('searchResultsSponsoredProducts')}
              showRatingStars={showRatingStars}
              heartsList={heartsList}
            />
          );
        }
        )}
      </div>
    </aside>
  );
};

SponsoredProducts.contextTypes = {
  testId: PropTypes.func,
  marketplace: PropTypes.object
};

export default SponsoredProducts;
